!function() {
  "use strict";
  customElements.get("ajax-modal") || customElements.define("ajax-modal", class extends HTMLElement {
    button=this.querySelector("a");
    url=this.button?.href;
    view=this.dataset.view;
    parent=this.closest("li") || this.closest(".shopify-section");
    delay=0;
    clickHandler=null;
    constructor() {
      super();
    }
    loadStart() {
      this.parent?.classList.add("opacity-50", "cursor-wait");
    }
    loadEnd() {
      this.parent?.classList.remove("opacity-50", "cursor-wait");
    }
    load() {
      this.loadStart();
      let t = new URL(this.url);
      this.view && t.searchParams.set("view", this.view), fetch(t).then((e => {
        if (e.ok) return e.text();
        console.warn(e), location.href = t;
      })).then((t => {
        document.body.insertAdjacentHTML("beforeend", t), setTimeout((() => document.getElementById(this.modalId)?.click()), this.hasAttribute("data-index") ? this.delay : 0);
      })).catch((e => {
        console.warn(e), location.href = t;
      })).finally((() => {
        this.loadEnd();
      }));
    }
    connectedCallback() {
      this.url && (this.modalId = this.url.split("/"), this.modalId = "Modal-" + this.modalId[this.modalId.length - 1].split("?")[0], 
      this.view && (this.modalId += `-${this.view}`), this.clickHandler = t => {
        if (t.preventDefault(), document.getElementById(this.modalId)) if (this.hasAttribute("data-index")) {
          const t = document.querySelector(`#${this.modalId} ~ div vanilla-slider`);
          t && t.dispatchEvent(new CustomEvent("goto", {
            bubbles: !1,
            detail: {
              index: parseInt(this.dataset.index)
            }
          })), setTimeout((() => document.getElementById(this.modalId).checked = !0), this.delay);
        } else document.getElementById(this.modalId).checked = !0; else this.hasAttribute("data-index") && (window.index = parseInt(this.dataset.index)), 
        this.load();
      }, this.button.addEventListener("click", this.clickHandler));
    }
    disconnectedCallback() {
      this.button && this.clickHandler && this.button.removeEventListener("click", this.clickHandler);
    }
  });
}();